var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtSvez(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66.77 216.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.19,210.7L44.95,54.5c-.19-1.41-1.22-2.44-2.42-2.44h-15.65c-1.2,0-2.23,1.03-2.42,2.44L3.22,210.7c-.21,1.58.69,3.07,2.03,3.33.13.02.26.04.39.04,1.18,0,2.22-1.02,2.42-2.44l3.47-25.51h46.35l3.47,25.51c.19,1.43,1.24,2.44,2.42,2.44.13,0,.26-.01.39-.04,1.34-.26,2.25-1.74,2.03-3.33ZM28.96,57.86h11.48l2.81,20.67h-17.1l2.81-20.67Zm-3.6,26.48h18.68l2.67,19.64h-24.02l2.67-19.64Zm-3.46,25.44h25.59l2.67,19.64h-30.94l2.67-19.64Zm-3.46,25.44h32.51l2.67,19.64H15.78l2.67-19.64Zm16.26,45.08H12.32l2.67-19.64h39.43l2.67,19.64h-22.39Z",
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.32,215.57l-27.77-14.92,24.07-13.14c.3-.16.48-.52.47-.9s-.21-.73-.51-.87l-24.05-11.62,21.25-10.27c.3-.14.49-.48.51-.86s-.16-.73-.45-.9l-21.66-12.92,18.52-11.05c.27-.16.44-.48.45-.83.01-.35-.14-.68-.4-.87l-18.78-13.2,14.77-10.38c.23-.16.38-.45.4-.77.02-.32-.1-.63-.32-.83l-15.12-13.77,10.55-9.61c.18-.16.29-.4.31-.66.02-.26-.04-.52-.18-.72l-10.96-15.71,6.57-9.41-1.26-1.23-6.37,9.12-6.37-9.12-1.26,1.23,6.57,9.41-10.96,15.71c-.14.2-.21.46-.18.72.03.26.14.5.31.66l10.55,9.61-15.12,13.77c-.21.2-.33.5-.32.83.02.32.17.61.4.77l14.77,10.38-18.78,13.2c-.26.18-.41.51-.4.87,0,.35.18.67.45.83l18.52,11.05-21.66,12.92c-.29.17-.46.52-.45.9s.21.71.51.86l21.26,10.27-24.05,11.62c-.3.15-.5.49-.51.88,0,.39.18.74.48.9l24.49,13.16-27.29,14.91h0c.36.93,1.46,1.33,2.34.85l26.92-14.7,27.4,14.72c.88.47,1.97.07,2.33-.87h0ZM24.15,86.94l10.22-14.65,10.22,14.65-10.23,9.32-10.22-9.32Zm-4.28,24.97l14.5-13.21,14.5,13.21-14.5,10.19-14.5-10.19Zm-3.76,25.28l18.27-12.84,18.27,12.84-18.27,10.9-18.27-10.9Zm-2.87,25.68l21.14-12.61,21.14,12.61-21.14,10.21-21.14-10.21Zm-2.7,23.81l23.84-11.51,23.85,11.52-23.64,12.91-24.05-12.92Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.32,213.28l-27.77-14.92,24.07-13.14c.3-.16.48-.52.47-.9s-.21-.73-.51-.87l-24.05-11.62,21.25-10.27c.3-.14.49-.48.51-.86s-.16-.73-.45-.9l-21.66-12.92,18.52-11.05c.27-.16.44-.48.45-.83.01-.35-.14-.68-.4-.87l-18.78-13.2,14.77-10.38c.23-.16.38-.45.4-.77.02-.32-.1-.63-.32-.83l-15.12-13.77,10.55-9.61c.18-.16.29-.4.31-.66.02-.26-.04-.52-.18-.72l-10.96-15.71,6.57-9.41-1.26-1.23-6.37,9.12-6.37-9.12-1.26,1.23,6.57,9.41-10.96,15.71c-.14.2-.21.46-.18.72.03.26.14.5.31.66l10.55,9.61-15.12,13.77c-.21.2-.33.5-.32.83.02.32.17.61.4.77l14.77,10.38-18.78,13.2c-.26.18-.41.51-.4.87,0,.35.18.67.45.83l18.52,11.05-21.66,12.92c-.29.17-.46.52-.45.9s.21.71.51.86l21.26,10.27-24.05,11.62c-.3.15-.5.49-.51.88,0,.39.18.74.48.9l24.49,13.16-27.29,14.91.68,1.76,28.57-15.6,29.05,15.61.68-1.76ZM24.15,84.65l10.22-14.65,10.22,14.65-10.23,9.32-10.22-9.32Zm-4.28,24.97l14.5-13.21,14.5,13.21-14.5,10.19-14.5-10.19Zm-3.76,25.28l18.27-12.84,18.27,12.84-18.27,10.9-18.27-10.9Zm-2.87,25.68l21.14-12.61,21.14,12.61-21.14,10.21-21.14-10.21Zm-2.7,23.81l23.84-11.51,23.85,11.52-23.64,12.91-24.05-12.92Z",
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.4,212.97L45.02,56.77c-.19-1.41-1.23-2.44-2.44-2.44h-15.76c-1.21,0-2.24,1.03-2.44,2.44L3,212.97c-.22,1.58.7,3.07,2.05,3.33.13.02.27.04.4.04,1.19,0,2.24-1.02,2.43-2.44l3.49-25.51h46.66l3.49,25.51c.2,1.43,1.24,2.44,2.43,2.44.13,0,.26-.01.4-.04,1.35-.26,2.26-1.74,2.05-3.33ZM28.92,60.13h11.55l2.83,20.67h-17.21l2.83-20.67Zm-3.62,26.48h18.8l2.69,19.64h-24.18l2.69-19.64Zm-3.48,25.44h25.77l2.69,19.64h-31.14l2.69-19.64Zm-3.48,25.44h32.73l2.69,19.64H15.65l2.69-19.64Zm16.37,45.08H12.16l2.69-19.64h39.7l2.69,19.64h-22.54Z",
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.19,210.7L44.95,54.5c-.19-1.41-1.22-2.44-2.42-2.44h-15.65c-1.2,0-2.23,1.03-2.42,2.44L3.22,210.7c-.21,1.58.69,3.07,2.03,3.33.13.02.26.04.39.04,1.18,0,2.22-1.02,2.42-2.44l3.47-25.51h46.35l3.47,25.51c.19,1.43,1.24,2.44,2.42,2.44.13,0,.26-.01.39-.04,1.34-.26,2.25-1.74,2.03-3.33ZM28.96,57.86h11.48l2.81,20.67h-17.1l2.81-20.67Zm-3.6,26.48h18.68l2.67,19.64h-24.02l2.67-19.64Zm-3.46,25.44h25.59l2.67,19.64h-30.94l2.67-19.64Zm-3.46,25.44h32.51l2.67,19.64H15.78l2.67-19.64Zm16.26,45.08H12.32l2.67-19.64h39.43l2.67,19.64h-22.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.45,
    y: 38.78,
    width: 42.51,
    height: 39.76,
    style: {
      fill: "#f47c4a",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.05,
    y: 103.98,
    width: 53.19,
    height: 25.44,
    style: {
      fill: "#f47c4a",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.52,
    y: 154.87,
    width: 60.24,
    height: 25.44,
    style: {
      fill: "#f47c4a",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m66.19,210.7L44.95,54.5c-.19-1.41-1.22-2.44-2.42-2.44h-15.65c-1.2,0-2.23,1.03-2.42,2.44L3.22,210.7c-.21,1.58.69,3.07,2.03,3.33.13.02.26.04.39.04,1.18,0,2.22-1.02,2.42-2.44l3.47-25.51h46.35l3.47,25.51c.19,1.43,1.24,2.44,2.42,2.44.13,0,.26-.01.39-.04,1.34-.26,2.25-1.74,2.03-3.33ZM28.96,57.86h11.48l2.81,20.67h-17.1l2.81-20.67Zm-3.6,26.48h18.68l2.67,19.64h-24.02l2.67-19.64Zm-3.46,25.44h25.59l2.67,19.64h-30.94l2.67-19.64Zm-3.46,25.44h32.51l2.67,19.64H15.78l2.67-19.64Zm16.26,45.08H12.32l2.67-19.64h39.43l2.67,19.64h-22.39Z",
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.16,
    y: 42.03,
    width: 49.08,
    height: 5.56,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.67,
    cy: 35.82,
    r: 7.84,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.67,
    cy: 53.79,
    r: 7.84,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6,
    y: 22.67,
    width: 6.08,
    height: 14.88,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6,
    width: 0.85,
    height: 22.67,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.83,
    y: 6.43,
    width: 0.85,
    height: 16.24,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.95,
    width: 0.85,
    height: 22.67,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.19,
    y: 6.43,
    width: 0.85,
    height: 16.24,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.95,
    y: 22.67,
    width: 6.08,
    height: 14.88,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.46,
    y: 36.96,
    width: 6.38,
    height: 15.69,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 28.26,
    width: 7.8,
    height: 33.1,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 28.26,
    width: 7.8,
    height: 33.1,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 42.03,
    width: 7.8,
    height: 5.56,
    style: {
      fill: "#f47c4a",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 42.03,
    width: 7.8,
    height: 5.56,
    style: {
      fill: "#f47c4a",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.99,
    y: 28.26,
    width: 27.41,
    height: 23.8,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.86,
    y: 52.06,
    width: 21.67,
    height: 5.8,
    style: {
      fill: "#010101"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtSvez);
export default __webpack_public_path__ + "static/media/BTSvez.f9e11699430060d84969742204891d58.svg";
export { ForwardRef as ReactComponent };